const Icon = ({title, name, nodeRef, ...props}) => (
    <div {...props} ref={nodeRef}>
        <i className={`icon-${name}`} title={title} />
    </div>
);

Icon.defaultProps = {
    name: 'slider-down',
    nodeRef: null,
};

export default Icon;
